// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__TK28J","socialContainer":"footer_socialContainer__5oUag"};